// src/com/veh_type_group/VehTypeGroupTree.js
import React, { useState } from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { CircularProgress, IconButton } from '@mui/material';
import HomeWorkIcon from '@mui/icons-material/HomeWork'; // dc
import CachedIcon from '@mui/icons-material/Cached'; // refresh
import AddCircleIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { AppStyle, AppWord } from '../../value/AppConst';
import { useReactiveVar } from '@apollo/client';
import { authTableTreeRepo } from '../../value/AppModel';
import { useAuthorizationCheck } from '../../api/app-hook';

const HoverColor = AppStyle.HoverColor;

const TreeHeader = styled(Box)({padding:'3px 10px 3px 10px', display: 'flex', alignItems: 'center', backgroundColor: '#f0f0f0', marginBottom:2});
const TitleBox = styled(Box)({flexGrow: 1});
const ToolBox = styled(Box)({
    display:'flex', alignItems:'center', justifyContent:'flex-end',
});
const DcTypeRecordBox = styled(Box)({
    marginBottom: 5, //     display: 'flex', alignItems: 'stretch',
});

const DcTypeBox = styled(Box)({
    width: 100, display: 'flex', alignItems: 'center', justifyContent: 'center',
    border: AppStyle.BorderCCC, borderRadius: 5, padding: 5, marginRight: 5
});

const DcRecordGroup = styled(Box)({
    flexGrow: 1, cursor: 'pointer', marginLeft:70
});
const DcRecordBox = styled(Box)({
    display: 'flex', alignItems: 'center', marginBottom: 5,
    borderBottom: AppStyle.BorderCCC, 
    '&:hover': {backgroundColor: HoverColor},
    '&:last-of-type': {marginBottom: 0}
});

const DcNameBox = styled(Box)({
    width: 120, padding: 5, flexGrow:1, // border: AppStyle.BorderCCC, borderRadius: 5, marginRight: 5
});
const GroupNameBox = styled(Box)({
    textAlign: 'right', // border: AppStyle.BorderCCC, borderRadius: 5,
    display: 'flex', alignItems: 'center', flexGrow: 1, fontSize: '0.8rem', paddingRight:10
});
const GroupNameText = styled(Box)({flexGrow: 1, padding: 5, });
const IconBox = styled(Box)({display: 'flex', alignItems: 'center', width:80, justifyContent: 'end'});
const IconStyle = {fontSize: '11pt'};
export default function VehTypeGroupTree({
    tree,
    onSelection,
    onRequestAdd,
    onRequestEdit,
    onRequestRemove,
    onRequestReload,
    loadingAny
}) {
    const [dcTypeHover, setDcTypeHover] = useState(null);
    const [dcHover, setDcHover] = useState(null);
    const [selectedDc, setSelectedDc] = useState({dcCd: null, vehTypeGpCd: null});
    const authTableTree = useReactiveVar(authTableTreeRepo);
    const checkAuth = useAuthorizationCheck();


    const onClickItem = (item) => {
        if(item.vehTypeGpCd) {
            setSelectedDc({dcCd: item.dcCd, vehTypeGpCd: item.vehTypeGpCd});
            onSelection(item);
        }
    };

    /*
	CALL wps_set_auth_table('pr_veh_type_group_add', '1,2', v_msg);
	CALL wps_set_auth_table('pr_veh_type_group_edit', '1,2', v_msg);
	CALL wps_set_auth_table('pr_veh_type_group_remove', '1,2', v_msg);
    */

    const canAdd = checkAuth(authTableTree.tree.pr_veh_type_group_add);
    const canEdit = checkAuth(authTableTree.tree.pr_veh_type_group_edit);
    const canRemove = checkAuth(authTableTree.tree.pr_veh_type_group_remove);

    const renderDcRecord = (record) => {
        const isSelected = selectedDc.dcCd === record.dcCd;

        return(
            <DcRecordBox key={record.dcCd}
                onClick={() => onClickItem(record)}
                onMouseEnter={() => setDcHover(record.dcCd)}
                onMouseLeave={() => setDcHover(null)}
            >
                <DcNameBox>
                    <HomeWorkIcon fontSize='0.8rem'
                        style={{marginRight: 5, color: isSelected ? 'red' : '#777'}}
                    /> {record.dcName}
                </DcNameBox>
                <GroupNameBox>
                    <GroupNameText>
                        {record.groupName || <span style={{color:'#777'}}>[없음]</span>}
                    </GroupNameText>
                    {
                        canAdd && dcHover === record.dcCd ?
                        <IconBox>
                            {
                                record.vehTypeGpCd ?
                                <>
                                <IconButton size={AppWord.SMALL}
                                    onClick={() => onRequestEdit(record)}
                                    style={{fontSize: '10pt'}}
                                    disabled={loadingAny || !canEdit}
                                    color={AppStyle.mui.primary}>
                                    <EditIcon style={IconStyle}/>
                                </IconButton>
                                <IconButton size={AppWord.SMALL}
                                    onClick={() => onRequestRemove(record)}
                                    style={{fontSize: '10pt'}}
                                    disabled={loadingAny || !canRemove}
                                    color={AppStyle.mui.warning}>
                                    <DeleteForeverIcon style={IconStyle}/>
                                </IconButton>
                                </>
                                :
                                <IconButton size={AppWord.SMALL}
                                    onClick={() => onRequestAdd(record)}
                                    style={{fontSize: '10pt'}}
                                    disabled={loadingAny || !canAdd}
                                    color={AppStyle.mui.primary}>
                                    <AddCircleIcon style={IconStyle} />
                                </IconButton>
                            }

                        </IconBox>
                        : null
                    }
                </GroupNameBox>
            </DcRecordBox>
        );
    };

    return(
        <Box style={{height:'100%', display:'flex', flexDirection:'column'}}>
            <TreeHeader>
                <TitleBox>물류센터 별 차종그룹 설정</TitleBox>
                <ToolBox>
                    {
                        loadingAny ?
                        <CircularProgress size={20} />
                        :
                        <IconButton
                            color={AppStyle.mui.inherit}
                            onClick={onRequestReload}
                            title='새로고침'
                            size={AppWord.SMALL}
                        >
                            <CachedIcon />
                        </IconButton>}
                </ToolBox>
            </TreeHeader>
            <Box style={{flexGrow:1, overflow:'auto'}}>
            {
                tree.map((typeObj, index) => {
                    return(
                        <DcTypeRecordBox key={index}
                            onMouseEnter={() => setDcTypeHover(typeObj.dcTypeCd)}
                            onMouseLeave={() => setDcTypeHover(null)}
                        >
                            <DcTypeBox
                                style={{
                                    backgroundColor: dcTypeHover === typeObj.dcTypeCd ? HoverColor : 'inherit'
                                }}
                            >
                                {typeObj.dcTypeName}
                            </DcTypeBox>
                            <DcRecordGroup>
                                {
                                    typeObj.children.map((record, index) => {
                                        return renderDcRecord(record);
                                    })
                                }
                            </DcRecordGroup>
                        </DcTypeRecordBox>
                    )
                })
            }
            </Box>
        </Box>
    );
}